class MySecurityClass {
  constructor(){
    console.log ("constructor from module class MyClass() ")
  }

  //email decryption
 static rot13(str) {
    return str.replace(/[a-zA-Z]/g, function(c) {
      return String.fromCharCode((c <= "Z" ? 90 : 122) >= (c = c.charCodeAt(0) + 13) ? c : c - 26);
    });
  }

  //phone number decryption
  static rot5(str) {
    return str.replace(/[0-90-9]/g, function(c) {
      return String.fromCharCode((c <= "9" ? 57 : 57) >= (c = c.charCodeAt(0) + 5) ? c : c - 10);
    });
  }


}

export default MySecurityClass